// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/foundations/colors.ts
export const colors = {
  gray: {
    50: '#F7FAFC',
    100: '#F5F7F9',
    200: '#E1E6EC',
    300: '#D7E1EA',
    400: '#CCD6DC',
    500: '#718096', // original
    600: '#747F8A',
    700: '#526572',
    800: '#323848',
    900: '#171923', // original
  },

  brand: {
    50: '#f2f7fb',
    100: '#d2f2ff',
    200: '#b4d6fe',
    300: '#99c8ee',
    400: '#2d85ec',
    500: '#1266c7',
    600: '#144ebf',
    700: '#023c77',
    800: '#00244a',
    900: '#000d1e',
  },

  red: {
    100: '#ffece9',
    500: '#ff3e1d',
  },

  orange: {
    500: '#fd670a',
  },

  yellow: {
    400: '#f2c94c',
  },

  green: {
    100: '#e7f5ea',
    500: '#0c9f2c',
  },
}
